class ToneGenerator {
  constructor() {
    this.audioCtx = null;
    this.timer = null;
    this.nodes = [];
  }

  init() {
    if (!this.audioCtx) {
      const AudioContextClass = window.AudioContext || window.webkitAudioContext;
      this.audioCtx = new AudioContextClass();
    }
    if (this.audioCtx.state === 'suspended') {
      this.audioCtx.resume().catch(() => {});
    }
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.nodes.forEach(node => {
      try { node.stop(); } catch {}
      try { node.disconnect(); } catch {}
    });
    this.nodes = [];
  }

  playDialTone() {
    this.stop();
    this.init();
    
    const playPulse = () => {
      if (!this.audioCtx) return;
      const t = this.audioCtx.currentTime;
      // We create two oscillators to make a rich telephone ring (400Hz + 450Hz)
      const osc1 = this.audioCtx.createOscillator();
      const osc2 = this.audioCtx.createOscillator();
      const gain = this.audioCtx.createGain();

      osc1.frequency.setValueAtTime(400, t);
      osc2.frequency.setValueAtTime(450, t);
      osc1.type = 'sine';
      osc2.type = 'sine';

      gain.gain.setValueAtTime(0, t);
      gain.gain.linearRampToValueAtTime(0.12, t + 0.05);
      gain.gain.setValueAtTime(0.12, t + 1.2);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 1.3);

      osc1.connect(gain);
      osc2.connect(gain);
      gain.connect(this.audioCtx.destination);

      osc1.start(t);
      osc2.start(t);
      osc1.stop(t + 1.3);
      osc2.stop(t + 1.3);

      this.nodes.push(osc1, osc2, gain);
      setTimeout(() => {
        this.nodes = this.nodes.filter(n => n !== osc1 && n !== osc2 && n !== gain);
      }, 1500);
    };

    playPulse();
    this.timer = setInterval(playPulse, 4000); // 4 seconds cycle
  }

  playRingtone() {
    this.stop();
    this.init();

    const playChime = () => {
      if (!this.audioCtx) return;
      const t = this.audioCtx.currentTime;
      const notes = [523.25, 659.25, 783.99, 1046.50]; // C5, E5, G5, C6
      
      notes.forEach((freq, idx) => {
        const osc = this.audioCtx.createOscillator();
        const gain = this.audioCtx.createGain();
        
        osc.frequency.setValueAtTime(freq, t + idx * 0.15);
        osc.type = 'triangle';
        
        gain.gain.setValueAtTime(0, t + idx * 0.15);
        gain.gain.linearRampToValueAtTime(0.12, t + idx * 0.15 + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.0001, t + idx * 0.15 + 0.5);
        
        osc.connect(gain);
        gain.connect(this.audioCtx.destination);
        
        osc.start(t + idx * 0.15);
        osc.stop(t + idx * 0.15 + 0.5);
        
        this.nodes.push(osc, gain);
        setTimeout(() => {
          this.nodes = this.nodes.filter(n => n !== osc && n !== gain);
        }, 1000);
      });
    };

    playChime();
    this.timer = setInterval(playChime, 2500); // Repeat every 2.5 seconds
  }
}

export const tonesPlayer = new ToneGenerator();
